<template>
  <div class="course-page">
    <!-- Плейсхолдер в стиле страницы курса, чтобы не прыгал экран и не был виден футер при загрузке -->
    <CoursePageSkeleton v-if="loading && !hasCourseDetails" />

    <div v-else-if="!slug || (hasError && !hasCourseDetails)" class="error">
      <p>{{ t('courseDetails.error') }}{{ errorText }}</p>
    </div>

    <div v-else-if="hasCourseDetails && course" class="course-content">
      <div class="course-container">
        <div class="back-button-wrap">
          <UIButton
            variant="secondary-arrow"
            arrow-direction="left"
            :href="backHref"
            :outline="false"
            :text="t('courseDetails.back')"
            padding="18px 34px"
            rounded="8px"
            size="large"
            @click="goBack"
          />
        </div>
        <div class="flex  custom-flex-wrap -mx-4 course-columns">
          <div class="course-main-col w-full md:w-2/3 lg:pr-[100px] px-4 mb-8 lg:mb-0">
            <CourseDescription
              :title="course.title"
              :description="course.description"
            />
            <CourseObjectives :items="learningObjectives" />
            <CourseCurriculum
              :sections="curriculumSections"
              :overview="curriculumOverview"
            />
            <template v-if="authorData?.name">
              <h3 class="author-title">{{ t('courseDetails.author.title') }}</h3>
              <CourseAuthor :author="authorData" />
            </template>
            <div class="course-review-form-wrapper pb-[100px]">
              <ContactForm
                :title="t('courseDetails.contactForm.title')"
                :subtitle="t('courseDetails.contactForm.subtitle')"
                :show-locality="true"
                :show-privacy-checkbox="true"
                :course-id="course?.id"
              />
            </div>
          </div>
          <div class="course-cover-col w-full md:w-1/3 px-4">
            <div class="course-cover-sidebar w-full max-w-[400px]">
              <CourseCover
                :title="course.title"
                :lessons-amount="course.lessonsAmount"
                :image-url="course.imageUrl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCourseDetails } from '@/composables/course'
import { useIndexRoutes } from '@/composables/locale/useIndexRoutes'

const { t } = useI18n()
definePageMeta({
  layout: 'full-width',
})

const {
  course,
  curriculumOverview,
  curriculumSections,
  learningObjectives,
  authorData,
  loading,
  error,
  errorText,
  hasCourseDetails,
  hasError,
  goBack,
  slug,
  backHref,
  loadCourseAndLessons,
} = useCourseDetails()

const { setupCourseDetailPageLoad } = useIndexRoutes()

onMounted(() => {
  loadCourseAndLessons()
})

setupCourseDetailPageLoad(loadCourseAndLessons)
</script>

<style scoped>
.course-page {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
}
@media (max-width: 767px) {
  .course-page {
    padding: 0px;
  }
}
.course-content {
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.course-container {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
  margin-top: 50px;
  overflow: visible;
}

/* Чтобы sticky работал: колонки тянутся на всю высоту ряда, правая колонка — не короче левой */
.course-columns {
  align-items: stretch;
}

.course-cover-col {
  align-self: stretch;
}

.back-button-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.course-review-form-wrapper {
  margin-bottom: 40px;
}

/* Десктоп: картинка курса sticky в своей колонке */
.course-cover-sidebar {
  position: sticky;
  top: 24px;
  /* padding-bottom: 140px; */
}

/* Мобильный: колонка с обложкой первой по порядку, обложка вверху в потоке (static) */
@media (max-width: 991px) {

  .course-cover-sidebar {
    position: static;
  }
}

.author-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 26px;
  line-height: 1.3;
  color: #000000;
  margin: 0 0 20px 0;
}

.error {
  text-align: center;
  padding: 60px 20px;
  font-family: var(--font-inter);
  color: #dc3545;
}

@media (max-width: 1400px) {
  .course-container {
    padding: 0 60px;
  }
}

@media (max-width: 991px) {
  .course-container {
    padding: 0 30px;
  }
  .custom-flex-wrap {
  flex-wrap: wrap;
}
}
@media (max-width: 960px) {
  .course-cover-col {
    order: -1;
  }
}
@media (max-width: 767px) {
  .course-container {
    padding: 0 20px;
  }
  .course-container {
    margin-top: 20px;
  }
}
</style>
